import { IStore } from '../index'

export const getDashboardData = (state: IStore) => state.dashboardCaReducer
